import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Button } from '../Button/index.js';
import { IconCategoryValue } from '../icon-category-value/index.js';
import kebabCase from 'lodash/kebabCase.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';
var _excluded = ["canClose", "category", "data", "disabled", "onClick", "onRemove", "sortable", "value"];
var Chip = function Chip(_ref) {
  var _ref$canClose = _ref.canClose,
    canClose = _ref$canClose === void 0 ? true : _ref$canClose,
    category = _ref.category,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    _ref$onRemove = _ref.onRemove,
    onRemove = _ref$onRemove === void 0 ? function () {} : _ref$onRemove,
    sortable = _ref.sortable,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  // @ts-ignore
  var getChipClasses = function getChipClasses() {
    return _formatClassName(['legacy-chip', {
      disabled: disabled
    }]);
  };
  var getDataAttributes = function getDataAttributes(data) {
    var dataProps = {};
    if (data.action) {
      dataProps['data-action'] = data.action;
    }
    if (data.objectId) {
      dataProps['data-object-id'] = data.objectId;
    }
    if (data.objectType) {
      dataProps['data-object-type'] = data.objectType;
    }
    if (data.componentType) {
      dataProps['data-component-type'] = data.componentType;
    } else {
      dataProps['data-component-type'] = value ? "".concat(kebabCase(value), "-chip") : 'chip';
    }
    return dataProps;
  };
  var performOnMouseDown = function performOnMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
  };
  var performOnClick = function performOnClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!disabled && onClick) {
      onClick();
    }
  };
  var performOnRemove = function performOnRemove(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!disabled) {
      onRemove();
    }
  };
  var dataAttributes = getDataAttributes(data);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: getChipClasses(),
    tabIndex: onClick && 0,
    onMouseDown: performOnMouseDown,
    onClick: performOnClick
  }, props, dataAttributes), /*#__PURE__*/React.createElement(IconCategoryValue, {
    icon: sortable ? 'grip-lines' : undefined,
    category: category,
    value: value
  }), canClose && /*#__PURE__*/React.createElement(Button, {
    rightIcon: "xmark",
    style: "link",
    disabled: disabled,
    onClick: performOnRemove,
    renderAsLegacy: true
  }));
};
Chip.displayName = "Chip";
Chip.displayName = 'Chip';
export { Chip };